<template>
  <div class="bg-[#13192e] rounded-[10px]"><slot /></div>
</template>

